const Calendar = () => import('pages/calendar/Calendar');
const index = () => import('pages/index/index');
const about = () => import('pages/aboutUs/about');
const login = () => import('pages/login/login');
const teacherDetail = () => import('pages/excellentCourse/teacherDetail');//老师详情
const excellentCourse = () => import('pages/excellentCourse/excellentCourse');//精品课程列表
const courseDetail = () => import('pages/course/courseDetail');//精品课程详情
const openClassDetail = () => import('pages/course/openClassDetail');//活动课程详情
const openClassList = () => import('pages/course/openClassList');//活动课程详情
const newsDetail = () => import('pages/news/newsDetail');//活动课程详情
const information = () => import('pages/information/information');//资讯入口页
const informationType = () => import('pages/information/informationType');//资讯分类页
const informationDetail = () => import('pages/information/informationDetail');//资讯详情页
const books = () => import('pages/index/books');//资讯详情页
const testIndex = () => import('pages/test/index');//资讯详情页
const notice = () => import('pages/test/notice');//资讯详情页
const result = () => import('pages/test/result');//资讯详情页
const exercise = () => import('pages/test/exercise');//资讯详情页
const detail = () => import('pages/test/detail');//资讯详情页
const newBook = () => import('pages/index/newBook');//资讯详情页


const routes = [
  {
    path: '/bkzx',
    components: {
      default: information
    },
    text: '资讯入口页',
    name: 'information',
    meta: {
      // keepAlive: true,
    },
    props: true
  },

  {
    path: '/bkzx/:firstLevel',
    components: {
      default: informationType
    },
    text: '资讯分类页',
    name: 'informationType',
    meta: {
      // keepAlive: true,
    },
    props: true
  },
  {
    path: '/bkzx/:firstLevel/:secondLevel.html',
    components: {
      default: informationDetail
    },
    text: '资讯列表页详情页',
    name: 'informationDetail',
    meta: {
      // keepAlive: true,
    },
    props: true
  },
  {
    path: '/bkq',
    components: {
      default: newsDetail
    },
    text: '资讯详情',
    name: 'newsDetail',
    meta: {
      // keepAlive: true,
    },
    props: true
  },
  {
    path: '/mstd/:name/:id.html',
    components: {
      default: teacherDetail
    },
    text: '资深讲师详情',
    name: 'teacherDetail',
    meta: {
      // keepAlive: true,
    },
    props: true
  },
  {
    path: '/tfkc',
    components: {
      default: excellentCourse
    },
    text: '精品课程',
    name: 'excellentCourse',
    meta: {
      // keepAlive: true,
    },
    props: true
  },
  {
    path: '/',
    redirect: 'index',
  },
  {
    path: '/calendar',
    components: {
      default: Calendar
    },
    text: '换库日历',
    name: 'calendar',
    meta: {
      // keepAlive: true,
    },
    props: true
  },
  {
    path: '/index',
    components: {
      default: index
    },
    text: '申友GMAT',
    name: 'index',
    meta: {
      // keepAlive: true,
    },
    props: true
  },
  {
    path: '/snjz-ahout',
    components: {
      default: about
    },
    text: '关于申友',
    name: 'about',
    meta: {
      // keepAlive: true,
    },
    props: true
  },
  {
    path: '/login',
    components: {
      default: login
    },
    text: '登录',
    name: 'login',
    meta: {
      // keepAlive: true,
    },
    props: true
  },
  {
    path: '/tfkc/:name.html',
    components: {
      default: courseDetail
    },
    text: '课程详情',
    name: 'courseDetail',
    props: true
  }, {
    path: '/gkk',
    components: {
      default: openClassList
    },
    name: 'openClassList',
    text: '活动列表页',
    props: true
  }, {
    path: '/gkk/:cate/:id',
    components: {
      default: openClassDetail
    },
    name: 'openClassDetail',
    text: '活动详情',
    props: true
  }, {
    path: '/books',
    components: {
      default: books
    },
    name: 'books',
    text: '活动详情',
    props: true
  }, {
    path: '/testIndex',
    components: {
      default: testIndex
    },
    name: 'testIndex',
    text: '水平速测首页',
    props: true
  }, {
    path: '/notice',
    components: {
      default: notice
    },
    name: 'notice',
    text: '测评提示页',
    props: true
  }, {
    path: '/result',
    components: {
      default: result
    },
    name: 'result',
    text: '测评结果页',
    props: true
  }, {
    path: '/exercise',
    components: {
      default: exercise
    },
    name: 'exercise',
    text: '测评页',
    props: true
  }, {
    path: '/detail',
    components: {
      default: detail
    },
    name: 'detail',
    text: '测评页',
    props: true
  }, {
    path: '/newBook',
    components: {
      default: newBook
    },
    name: 'newBook',
    text: '新书宣传',
    props: true
  },
]

export default routes




// WEBPACK FOOTER //
// ./src/router/routes.js